module.exports = __webpack_public_path__ + "static/media/next.798fb448.svg";